import React from "react";
import { Button } from "antd";

export const withPaginated = conditionFn => Component => props => (
  <div>
    <Component {...props} />

    <div className="interactions">
      {conditionFn(props) && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          {props.hasScroll ? (
            <Button onClick={props.onPaginatedSearch}>Next Page</Button>
          ) : (
            <div>
              <div style={{ marginBottom: 20 }}>Something went wrong...</div>
              <Button onClick={props.onPaginatedSearch}>Try Again</Button>}
            </div>
          )}
        </div>
      )}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/hoc/withPaginated.js